import { useEffect, useRef, useState } from 'react';

// Anbar: «🧮 İtki hesabla». Sadə kalkulyator, heç nə yadda saxlamır.
// Alınan miqdar + alış məbləği + itki (və ya qalan) → 1 kq/lt-a düşən itki, real maya.

const num = (v) => {
    const n = parseFloat(String(v ?? '').replace(',', '.'));
    return Number.isFinite(n) ? n : null;
};
const fmt = (n, d = 3) => {
    if (n == null || !Number.isFinite(n)) return '-';
    return String(+n.toFixed(d));
};

const UNITS = {
    kg:   { big: 'kq', small: 'q' },
    litr: { big: 'lt', small: 'ml' },
};

export default function LossCalcModal({ open, onClose }) {
    const [unit, setUnit] = useState('kg');
    const [bought, setBought] = useState('');
    const [price, setPrice] = useState('');
    const [loss, setLoss] = useState('');
    const [left, setLeft] = useState('');
    const firstRef = useRef(null);

    useEffect(() => {
        if (!open) return;
        setBought(''); setPrice(''); setLoss(''); setLeft('');
        setTimeout(() => firstRef.current?.focus(), 50);
    }, [open]);

    if (!open) return null;

    const u = UNITS[unit];
    const b = num(bought);
    const p = num(price);

    // İtki və qalan bir-birini tamamlayır: birini yazanda o biri hesablanır
    const onBought = (v) => {
        setBought(v);
        const nb = num(v), nl = num(loss);
        if (nb != null && nl != null) setLeft(fmt(nb - nl));
    };
    const onLoss = (v) => {
        setLoss(v);
        const nl = num(v);
        setLeft(b != null && nl != null ? fmt(b - nl) : '');
    };
    const onLeft = (v) => {
        setLeft(v);
        const nr = num(v);
        setLoss(b != null && nr != null ? fmt(b - nr) : '');
    };

    const l = num(loss);
    const r = num(left);
    const valid = b != null && b > 0 && l != null && l >= 0 && l <= b;
    const perUnit = valid ? l / b : null;              // 1 kq-a düşən itki (kq)
    const buyPrice = valid && p != null ? p / b : null; // ₼/kq alış
    const realPrice = valid && p != null && r > 0 ? p / r : null; // ₼/kq itkidən sonra
    const lostMoney = valid && p != null ? p * l / b : null;

    const field = 'h-11 w-full rounded-xl border-2 border-gray-200 px-3 text-base font-semibold text-gray-800 focus:border-primary-400 focus:outline-none';
    const label = 'mb-1 block text-xs font-semibold uppercase text-gray-500';

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/45 p-4" onMouseDown={onClose}>
            <div className="w-full max-w-md rounded-2xl bg-white p-5 shadow-2xl" onMouseDown={(e) => e.stopPropagation()}
                onKeyDown={(e) => { if (e.key === 'Escape') onClose(); }}>
                <div className="mb-4 flex items-center justify-between">
                    <div className="text-lg font-black text-gray-800">🧮 İtki hesabla</div>
                    <div className="flex rounded-xl bg-gray-100 p-1">
                        {Object.entries(UNITS).map(([k, v]) => (
                            <button key={k} type="button" onClick={() => setUnit(k)}
                                className={`rounded-lg px-3 py-1 text-sm font-bold ${unit === k ? 'bg-white text-gray-800 shadow-sm' : 'text-gray-500'}`}>{v.big}</button>
                        ))}
                    </div>
                </div>

                <div className="grid grid-cols-2 gap-3">
                    <div>
                        <label className={label}>Alınan ({u.big})</label>
                        <input ref={firstRef} inputMode="decimal" value={bought} onChange={(e) => onBought(e.target.value)}
                            placeholder="11.200" className={field} />
                    </div>
                    <div>
                        <label className={label}>Alış məbləği (₼)</label>
                        <input inputMode="decimal" value={price} onChange={(e) => setPrice(e.target.value)}
                            placeholder="35" className={field} />
                    </div>
                    <div>
                        <label className={label}>İtki ({u.big})</label>
                        <input inputMode="decimal" value={loss} onChange={(e) => onLoss(e.target.value)}
                            placeholder="5" className={field} />
                    </div>
                    <div>
                        <label className={label}>Qalan ({u.big})</label>
                        <input inputMode="decimal" value={left} onChange={(e) => onLeft(e.target.value)}
                            placeholder="6.200" className={field} />
                    </div>
                </div>

                {b != null && l != null && l > b && (
                    <div className="mt-3 rounded-xl bg-red-50 px-3 py-2 text-xs font-semibold text-red-600">İtki alınan miqdardan çox ola bilməz.</div>
                )}

                <div className="mt-4 rounded-2xl border border-primary-100 bg-primary-50/60 p-4">
                    <div className="text-xs font-semibold uppercase text-gray-500">1 {u.big}-a düşən itki</div>
                    <div className="mt-1 text-2xl font-black text-primary-700">
                        {perUnit == null ? '-' : `${fmt(perUnit)} ${u.big}`}
                        {perUnit != null && <span className="ml-2 text-base font-bold text-gray-500">({fmt(perUnit * 1000, 0)} {u.small})</span>}
                    </div>
                    {perUnit != null && (
                        <div className="mt-0.5 text-sm font-semibold text-gray-500">İtki faizi: {fmt(perUnit * 100, 1)}%</div>
                    )}

                    <div className="mt-3 grid grid-cols-3 gap-2 border-t border-primary-100 pt-3 text-center">
                        <div>
                            <div className="text-[11px] font-semibold text-gray-500">Alış qiyməti</div>
                            <div className="text-sm font-black text-gray-800">{buyPrice == null ? '-' : `${fmt(buyPrice, 3)} ₼/${u.big}`}</div>
                        </div>
                        <div>
                            <div className="text-[11px] font-semibold text-gray-500">Real maya</div>
                            <div className="text-sm font-black text-orange-600">{realPrice == null ? '-' : `${fmt(realPrice, 3)} ₼/${u.big}`}</div>
                        </div>
                        <div>
                            <div className="text-[11px] font-semibold text-gray-500">İtkiyə gedən</div>
                            <div className="text-sm font-black text-red-600">{lostMoney == null ? '-' : `${fmt(lostMoney, 2)} ₼`}</div>
                        </div>
                    </div>
                </div>

                <button type="button" onClick={onClose}
                    className="mt-4 w-full rounded-xl border border-gray-200 py-2.5 text-sm font-bold text-gray-500 hover:bg-gray-50">Bağla</button>
            </div>
        </div>
    );
}
